import { Routes } from '@angular/router';
import { UsersComponent } from 'src/app/users/users.component';
import { AuthGuard } from '../auth/auth-guard.service';
import { AdminRoleTypeEnum } from '../auth/AdminRoleTypeEnum';
// import { CompaniesComponent } from 'src/app/companies/companies.component';
import { PlayersComponent } from 'src/app/players/players.component';
import { PlayerDetailsComponent } from 'src/app/players/player-details/player-details.component';

// Route for content layout with sidebar, navbar and footer.

export const fullRoutes: Routes = [
  {
    path: '',
    component: PlayersComponent,
    canActivate: [AuthGuard],
    data: { role: AdminRoleTypeEnum.ADMIN },
  },
  {
    path: '',
    loadChildren: () =>
      import('../../game/game.module').then((m) => m.GameModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('../../feedback/feedback.module').then((m) => m.FeedbackModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'pages',
    loadChildren: () =>
      import('../../pages/full-pages/full-pages.module').then(
        (m) => m.FullPagesModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [AuthGuard],
    data: { role: AdminRoleTypeEnum.ADMIN },
  },
  // we don't need companies for now
  // {
  //   path: 'companies',
  //   component: CompaniesComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'divisions',
    loadChildren: () =>
      import('../../divisions/divisions.module').then((m) => m.DivisionsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'players',
    component: PlayersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'players/:id',
    component: PlayerDetailsComponent,
    canActivate: [AuthGuard],
  },
];
